export default __webpack_public_path__ + "static/media/cloudy.7e82fef4.svg";